import React from 'react';
import Login from '../../components/Login/Login';
import { loginWithCompanyAndPassword } from '../../store/actions/backendAuth';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import type { RootState } from '../../store/types';

function LoginContainer() {
    const dispatch = useAppDispatch();
    const pending = useAppSelector((state: RootState) => state.user.authWithPasswordPending);
    const error = useAppSelector((state: RootState) => state.user.authWithPasswordError);

    return (
        <Login
            pending={pending}
            error={error}
            doLogin={(locationName: string, username: string, password: string) =>
                dispatch(loginWithCompanyAndPassword(locationName, username, password))
            }
        />
    );
}

export default LoginContainer;
